import JSEncrypt from "jsencrypt";

export const publicKey = process?.env?.REACT_APP_PUBLIC_KEY || "";

const dataEncryptor = (dataToBeEncrypted) => {
  const rsaEncrypt = new JSEncrypt();
  rsaEncrypt.setPublicKey(publicKey);
  const encryptedKey = rsaEncrypt.encrypt(dataToBeEncrypted);
  return encryptedKey;
};

const getEncryptedParams = (data) => dataEncryptor(data);

export { getEncryptedParams };
